import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../services/apiService';
import { mapState, mapGetters } from 'vuex';
import clone from 'lodash/clone';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'ViewHome',
  data: function data() {
    return {
      pwValue: '',
      favorites: [],
      tileSizeSetting: parseInt(localStorage.getItem('tileSize')) || 0,
      defaultTileSize: {
        sm: 6,
        dm: 4,
        lg: 3,
        xl: 2
      },
      bigTileSize: {
        sm: 12,
        dm: 6,
        lg: 4,
        xl: 3
      },
      firstSteps: [{
        title: this.$i18n_t('Common.home.firstStep1'),
        text: this.$i18n_t('Common.home.firstStepHint1'),
        image: './img/firstSteps/star.svg',
        link1: '/fm-add-ticket',
        link2: '/fm-add-ticket',
        link3: '/fm-add-ticket'
      }, {
        title: this.$i18n_t('Common.home.firstStep2'),
        text: this.$i18n_t('Common.home.firstStepHint2'),
        image: './img/firstSteps/settings.svg',
        link1: '/fm-add-ticket',
        link2: '/fm-add-ticket',
        link3: '/fm-add-ticket'
      }, {
        title: this.$i18n_t('Common.home.firstStep3'),
        text: this.$i18n_t('Common.home.firstStepHint3'),
        image: './img/firstSteps/team.svg',
        link1: '/fm-add-ticket',
        link2: '/fm-add-ticket',
        link3: '/fm-add-ticket'
      }],
      announcement: null,
      dialog: false,
      showFirstSteps: false,
      dialogNo: 0,
      componentKey: 1
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'announcements'])), mapGetters({
    sessionUserId: 'authentication/userId',
    sessionUser: 'authentication/user',
    tenantId: 'authentication/tenantId'
  })), {}, {
    canCreateTickets: function canCreateTickets() {
      return this.permissions['IsFmTicket.create'] || this.permissions['IsFmTicket.manage'];
    },
    hasAdminRights: function hasAdminRights() {
      return this.permissions['all.manage'];
    },
    tileSize: function tileSize() {
      if (this.tileSizeSetting === 0) {
        return this.defaultTileSize;
      }

      if (this.tileSizeSetting === 1) {
        return this.bigTileSize;
      }

      return this.defaultTileSize;
    },
    shouldDisplayAnnouncement: function shouldDisplayAnnouncement() {
      if (!this.announcements.length || !this.announcements[0].active || this.announcements[0].presentationType !== 'message') {
        return false;
      }

      var now = new Date();
      var startDate = new Date(this.announcements[0].start);
      var endDate = new Date(this.announcements[0].end);
      return (this.announcements[0].start === null || startDate <= now) && (this.announcements[0].end === null || endDate >= now);
    }
  }),
  mounted: function mounted() {
    this.getFavorites();
  },
  methods: {
    openDialog: function openDialog(i) {
      this.dialog = true;
      this.dialogNo = i;
    },
    getFavorites: function getFavorites() {
      var _this = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      ApiService.fetchFavoritesByUserId(this.sessionUserId).then(function (favorites) {
        if (_this.canCreateTickets && favorites.length) {
          favorites.splice(0, 0, {
            type: 'createTicket'
          });
        }

        _this.favorites = favorites;

        if (!_this.favorites.length) {
          _this.showFirstSteps = true;
        }
      }).catch(function (error) {
        console.error('Error while loading favorites.', error);
      }).finally(function () {
        _this.$store.state.app.loading = false;
      });
    },
    removeFavorite: function removeFavorite(itemId) {
      this.favorites = this.favorites.filter(function (f) {
        return f.id !== itemId;
      });
      this.favorites = clone(this.favorites);
    },
    closeAlert: function closeAlert() {
      var announcementId = get(this.$store.state.app, 'announcements[0].id');
      var userAnnouncements = get(this.sessionUser, 'properties.announcements', []);
      this.announcement = this.announcements[0];
      this.$store.state.app.announcements = this.$store.state.app.announcements.slice(1);

      if (announcementId) {
        set(this.sessionUser, 'properties.announcements', userAnnouncements.filter(function (a) {
          return parseInt(a) !== parseInt(announcementId);
        }));
        this.updateUser(this.sessionUser);
      }
    },
    updateUser: function updateUser(userData) {
      var _this2 = this;

      return ApiService.updateUser(userData).then(function () {
        _this2.updateAnnouncementState(_this2.announcement);
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateAnnouncementState: function updateAnnouncementState(announcement) {
      return ApiService.tenantUpdateSystemAnnouncementState(this.tenantId, announcement);
    },
    sizeUp: function sizeUp() {
      this.tileSizeSetting = 1;
      localStorage.setItem('tileSize', 1);
      this.componentKey += 1;
    },
    sizeDown: function sizeDown() {
      this.tileSizeSetting = 0;
      localStorage.setItem('tileSize', 0);
      this.componentKey += 1;
    },
    pushToRouter: function pushToRouter(path) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.$router.push({
        path: path,
        query: {
          parent: selected ? selected.id : null,
          openTree: JSON.stringify(this.open)
        }
      });
    }
  }
};